module.exports = __webpack_public_path__ + "img/img-work_detail.8bf1c44e.png";